import type { BBox, Point } from 'geojson'
import type { KgType } from '@/lib/knowledge-graph/types'

/** Knowledge Graph entity type to query for for a given QuickSearchOption */
export enum QuickSearchEntityType {
  HikeRoute = 'HikeRoute',
  OffroadRoute = 'OffroadRoute',
}

/** Supported Knowledge Graph filters for quick search queries */
export type QuickSearchFilter = {
  amenities?: {
    slug: {
      in: string[]
    }
  }
  promotionReasons?: {
    contains: string
  }
  location?: {
    near?: {
      lat: number
      lon: number
      distance: number
    }
    nearTile?: {
      z: number
      x: number
      y: number
      distance: number
    }
    withinBounds?: {
      bottom: number
      left: number
      right: number
      top: number
    }
  }
  limit?: number
}

/** Configuration for a single quick search option */
export type QuickSearchOption = {
  slug: string
  label: string
  icon: string
  resultsTitle: string
  entityType: QuickSearchEntityType
  queryFilter: QuickSearchFilter
}

/** Set of quick search options */
export type QuickSearchCategories = QuickSearchOption[]

/** Config for the quick search feature */
export type QuickSearchConfig = {
  title: string
  searchInputCopy: string
  options: QuickSearchCategories
}

/** Provider configuration state - can be configured with a QuickSearchConfig or null if not configured */
export type QuickSearchProviderConfig = QuickSearchConfig | null

/** Shape of results from a base quick search query */
export interface QuickSearchBaseResponse {
  __typename: string
  id: string
  name: string
  location: Point
  extent: BBox
  near: {
    name: string
    state: {
      abbreviation: string
    }
  }[]
  photos?: {
    contentUrl: string
  }[]
}

export interface OffroadRouteQuickSearchResponse extends QuickSearchBaseResponse {
  richPlace: {
    id: string
  }
}

/** Standardized quick search result shape */
export type QuickSearchResult = {
  __typename: KgType
  id: string
  name: string
  location: Point
  extent: BBox
  near?: string
  distanceAway?: number
  imageUrl?: string
  [key: string]: unknown
}
